import { useState, useRef, useCallback } from "react";
import PropTypes from "prop-types";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import "./user-filter.css";
import CommonSearchBar from "../../common/searchBar/CommonSearchBar";
import CommonSelect from "../../common/CommonSelect";
import UserAddPopup from "./user-add-popup/user-add-popup";
import { Button, useMediaQuery, useTheme, Box } from "@mui/material";

const UserFilter = (props) => {
  const {
    role,
    setRole,
    onSearch,
    roles,
    canWrite = false,
    existingUsers = [],
    onUserAdded,
  } = props;
  const [isOpenAddPopup, setIsOpenAddPopup] = useState(false);

  const [isResetSearch] = useState(false);
  const searchRef = useRef(null);

  const roleOptions =
    Array.isArray(roles) && roles.length > 0
      ? roles.map((r) => r.name)
      : ["L1", "L2", "L3", "L4", "L5", "L6", "L7", "L8", "L9"];
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [roleAnchorEl, setRoleAnchorEl] = useState(null);
  const roleSelectOpen = Boolean(roleAnchorEl);

  const handleObjectChange = (value) => {
    const current = Array.isArray(role) ? role : [];
    const exists = current.includes(value);
    const next = exists
      ? current.filter((v) => v !== value)
      : [...current, value];
    setRole(next);
  };
  const handleOpenRoleSelect = (e) => {
    setRoleAnchorEl(e.currentTarget);
  };
  const handleCloseRoleSelect = () => {
    setRoleAnchorEl(null);
  };
  const handleSearch = useCallback(
    (value) => {
      if (onSearch) {
        onSearch(value);
      }
    },
    [onSearch],
  );

  const handleCloseAddPopup = () => {
    setIsOpenAddPopup(false);
  };

  let roleDisplayText;
  if (Array.isArray(role) && role.length > 0) {
    roleDisplayText = role.join(", ");
  } else if (isMobile) {
    roleDisplayText = "Roles";
  } else {
    roleDisplayText = "Select Role";
  }

  return (
    <>
      <div className="company-dashboard-user-filter">
        <div className="company-dashboard-filter-content">
          <div className="company-dashboard-filter-content-right">
            <div className="company-dashboard-filter-content-right-item">
              {!isMobile && (
                <div className="company-dashboard-filter-content-right-item-label">
                  Role
                </div>
              )}

              <Box
                onClick={handleOpenRoleSelect}
                sx={{
                  borderRadius: "30px",
                  backgroundColor: "#fff",
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#403C6F",
                  px: 2,
                  py: 1,
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  minHeight: "40px",
                  boxShadow: "0 0 0 1px transparent",
                  "&:hover": { boxShadow: "0 0 0 1px #403C6F" },
                }}
              >
                <span>{roleDisplayText}</span>
                <ExpandMoreIcon sx={{ ml: 1, color: "#403C6F" }} />
              </Box>
              <CommonSelect
                id="role-select"
                open={roleSelectOpen}
                anchorEl={roleAnchorEl}
                onClose={handleCloseRoleSelect}
                noteTypes={roleOptions}
                selectedTypes={Array.isArray(role) ? role : []}
                handleSelectAll={() => {
                  const allSelected =
                    Array.isArray(role) && role.length === roleOptions.length;
                  setRole(allSelected ? [] : [...roleOptions]);
                }}
                handleTypeToggle={(value) => {
                  handleObjectChange(value);
                }}
                multiple={true}
                width={300}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
              />
            </div>
          </div>
          <div className="company-dashboard-filter-content-left">
            <div className="company-dashboard-filter-content-left-item">
              <div className="user-filter-content-search">
                <CommonSearchBar
                  onSearch={handleSearch}
                  isReset={isResetSearch}
                  ref={searchRef}
                  placeholder="Search user"
                />
              </div>
              {canWrite && (
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => setIsOpenAddPopup(true)}
                  className="add-user-btn"
                  sx={{
                    backgroundColor: "#403C6F",
                    color: "#fff",
                    borderRadius: "20px",
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: "14px",
                    px: 2.5,
                    height: "40px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    whiteSpace: "nowrap",
                    boxShadow: "none",
                    "&:hover": {
                      backgroundColor: "#2f2b5a",
                      boxShadow: "0 2px 6px rgba(64, 60, 111, 0.2)",
                    },
                  }}
                >
                  Add User
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
      <UserAddPopup
        isOpen={isOpenAddPopup}
        onClose={handleCloseAddPopup}
        roles={roles}
        existingUsers={existingUsers}
        onUserAdded={onUserAdded}
      />
    </>
  );
};

UserFilter.propTypes = {
  role: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  setRole: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  roles: PropTypes.array,
  canWrite: PropTypes.bool,
  existingUsers: PropTypes.array,
  onUserAdded: PropTypes.func,
};

export default UserFilter;
